export const eur = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const num = (n) => new Intl.NumberFormat("es-ES").format(Number(n || 0));

export const ESTADOS = {
  borrador: { label: "Borrador", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  emitida: { label: "Emitida", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  aceptado: { label: "Aceptado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  enviado: { label: "Enviado", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  cobro_parcial: { label: "Cobro parcial", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  cobrada: { label: "Cobrada", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  vencida: { label: "Vencida", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  anulada: { label: "Anulada", cls: "bg-slate-100 text-slate-500 border-slate-300" },
  rectificada: { label: "Rectificada", cls: "bg-slate-100 text-slate-500 border-slate-300" },
  rectificativa: { label: "Rectificativa", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  firmado: { label: "Firmado", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  facturado: { label: "Facturado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const estadoDoc = (d) => (d?.estado === "anulada" && d.anulacion?.motivo
  ? { ...ESTADOS.anulada, label: `Anulada (${d.anulacion.motivo.toLowerCase()})` }
  : ESTADOS[d?.estado] || ESTADOS.emitida);

export const CATEGORIAS_GASTO = [
  { value: "materiales", label: "Materiales" },
  { value: "mano_obra", label: "Mano de obra" },
  { value: "subcontratas", label: "Subcontratas" },
  { value: "suministros", label: "Suministros" },
  { value: "fiscal", label: "Fiscal / Impuestos" },
];

export const RAMAS_MANO_OBRA = [
  { value: "albanil_oficial", label: "Albañil oficial" },
  { value: "fontanero", label: "Fontanero" },
  { value: "electricista", label: "Electricista" },
  { value: "carpinteria_madera", label: "Carpintería madera" },
  { value: "carpintero_aluminio", label: "Carpintero aluminio" },
  { value: "gestion_residuos", label: "Gestión de residuos" },
  { value: "transportes", label: "Transportes" },
  { value: "peones", label: "Peones / Ayudantes" },
  { value: "gestiones_comerciales", label: "Gestiones comerciales" },
];

export const RAMA_LABEL = {
  ...Object.fromEntries(RAMAS_MANO_OBRA.map((r) => [r.value, r.label])),
  sin_especificar: "Sin especificar",
};

export const ESTADO_OBRA = {
  activa: { label: "Activa", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  en_pausa: { label: "En pausa", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  finalizada: { label: "Finalizada", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  archivada: { label: "Archivada", cls: "bg-slate-200 text-slate-700 border-slate-300" },
};
